<script setup lang="ts"></script>

<template>
	<div class="fixed top-0 left-0 z-90 flex size-full flex-col items-center justify-center bg-neutral-700 p-8">
		<div class="z-10 w-full max-w-2xl min-w-fit">
			<div class="relative flex size-full min-h-fit min-w-fit flex-col gap-y-5 rounded-3xl bg-white p-8 md:p-10">
				<!-- Modal Body -->
				<div class="flex size-full min-h-fit flex-col items-center gap-y-4">
					<div class="flex flex-row items-center justify-center gap-x-4">
						<svg width="51" height="59" viewBox="0 0 51 59" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g id="smartphone-call 1" opacity="0.4">
								<g id="Group">
									<path
										id="Vector"
										d="M34.6519 0H8.34807C6.15664 0 4.36304 1.79191 4.36304 3.98503V55.0133C4.36304 57.2064 6.15664 59 8.34807 59H34.6519C36.8434 59 38.637 57.2098 38.637 55.015V3.98503C38.637 1.79191 36.8434 0 34.6519 0ZM17.2925 2.87246H25.7076C25.9739 2.87246 26.1897 3.08823 26.1897 3.35626C26.1897 3.6226 25.9739 3.83837 25.7076 3.83837H17.2925C17.0261 3.83837 16.8104 3.6226 16.8104 3.35626C16.8104 3.08823 17.0261 2.87246 17.2925 2.87246ZM21.5 57.0075C20.3992 57.0075 19.5075 56.1157 19.5075 55.0133C19.5075 53.9108 20.3992 53.0208 21.5 53.0208C22.6008 53.0208 23.4925 53.9108 23.4925 55.0133C23.4925 56.1157 22.6008 57.0075 21.5 57.0075ZM35.864 51.625H7.13604V6.31974H35.864V51.625Z"
										fill="#091B3D"
									/>
								</g>
							</g>
						</svg>

						<svg width="52" height="29" viewBox="0 0 52 29" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g id="Isolation_Mode" clip-path="url(#clip0_2456_6180)">
								<path
									id="Vector"
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M10.697 7.00995H17.1173V22.2173H10.697V7.00995Z"
									fill="#9DA4B1"
								/>
								<path
									id="Vector_2"
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M18.8483 7.11279H28.424V22.3166H18.8483V7.11279Z"
									fill="#9DA4B1"
								/>
								<path
									id="Vector_3"
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M51.1506 14.509L28.4241 28.6344V0.387085L51.1506 14.509Z"
									fill="#9DA4B1"
								/>
								<path
									id="Vector_4"
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M4.4812 7.00995H8.76137V22.2173H4.4812V7.00995Z"
									fill="#9DA4B1"
								/>
								<path
									id="Vector_5"
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0 6.9071H2.85227V22.1145H0V6.9071Z"
									fill="#9DA4B1"
								/>
							</g>
							<defs>
								<clipPath id="clip0_2456_6180">
									<rect width="51.1505" height="28.2473" fill="white" transform="translate(0 0.387085)" />
								</clipPath>
							</defs>
						</svg>

						<svg width="99" height="98" viewBox="0 0 99 98" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g id="laptop-3 1" clip-path="url(#clip0_2456_6189)">
								<g id="Group">
									<g id="Group_2">
										<path
											id="Vector"
											d="M97.9855 71.261C97.8925 71.153 97.7555 71.089 97.6115 71.089H1.21452C1.07052 71.089 0.934517 71.152 0.840517 71.261C0.746517 71.369 0.704517 71.514 0.725517 71.657C0.739517 71.747 2.19352 80.673 13.4785 80.673H85.3475C96.6315 80.673 98.0855 71.747 98.1005 71.657C98.1205 71.514 98.0785 71.369 97.9855 71.261ZM56.6625 77.547H42.1625V74.213H56.6625V77.547Z"
											fill="#1C64F2"
										/>
										<path
											id="Vector_2"
											d="M11.2275 67.619H87.5975C88.7015 67.619 89.5975 66.723 89.5975 65.619V18.713C89.5975 17.609 88.7015 16.713 87.5975 16.713H11.2275C10.1235 16.713 9.22754 17.609 9.22754 18.713V65.619C9.22754 66.723 10.1235 67.619 11.2275 67.619ZM16.2275 23.713H82.5975V60.619H16.2275V23.713Z"
											fill="#1C64F2"
										/>
									</g>
								</g>
							</g>
							<defs>
								<clipPath id="clip0_2456_6189">
									<rect width="97.385" height="97.385" fill="white" transform="translate(0.720459)" />
								</clipPath>
							</defs>
						</svg>
					</div>

					<p class="text-center text-2xl font-bold">Switch to a laptop or desktop to use Qweebi.</p>

					<p class="text-center text-lg font-normal">
						Qweebi doesn't work on mobile phones yet. To use Qweebi, log in to Qweebi website from your laptop or
						desktop.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped></style>
